import Game from '../../Game';
import { HelperFriendStatus } from '../../State/Level/HelperFriend/HelperFriendStatus';
import BaseUISystem from './BaseUISystem';
import HelperFriendHUDHandler from './HUD/HelperFriendHUDHandler';
import LevelHUDHandler from './HUD/LevelHUDHandler';
import ErrorMenuHandler from './Menu/ErrorMenuHandler';
import LevelCompleteMenuHandler from './Menu/LevelCompleteMenuHandler';
import SettingsMenuHandler from './Menu/SettingsMenuHandler';
import ShopMenuHandler from './Menu/ShopMenuHandler';
import SuitcaseBoosterHandler from './Menu/SuitcaseBoosterHandler';
import ResolveDataConflictMenuHandler from './Menu/ResolveDataConflictMenuHandler';
import NoCoinsMenuHandler from './Menu/NoCoinsMenuHandler';
import { IGameState } from '../../State/Game/IGameState';

export default class LevelUISystem extends BaseUISystem {
    public init(): void {
        const HUD = new LevelHUDHandler(this);

        this.handlers = [
            HUD,
            new SuitcaseBoosterHandler(this),
            new SettingsMenuHandler(this),
            new NoCoinsMenuHandler(this),
            new LevelCompleteMenuHandler(this),
            new ErrorMenuHandler(this),
        ];

        if (Game.state.getState().platform.IAPSupport) {
            this.handlers.push(new ShopMenuHandler(this));
        }

        if (
            Game.state.getState().levelState.helperFriendStatus ===
            HelperFriendStatus.ENABLED
        ) {
            this.handlers.push(new HelperFriendHUDHandler(this));
        }

        if (hasUIQueued(Game.state.getState(), 'resolveDataConflictMenu')) {
            this.handlers.push(new ResolveDataConflictMenuHandler(this));
        }
    }
}

function hasUIQueued(state: IGameState, popupID: string): boolean {
    return state.UIState.queue.find(task => task.popupID === popupID) !== null;
}
